module.exports = __webpack_public_path__ + "static/img/baner2.50e8458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/baner2.png
// module id = eHqF
// module chunks = 2